<template>
  <section class="card_style">
    <!-- skeleton -->
    <div class="row" v-if="loading && $route.params.id">
      <div class="col-12 my-3">
        <Skeleton width="20%" class="my-2"></Skeleton>
      </div>
      <div class="col-12 my-3" v-for="i in 2" :key="i">
        <Skeleton width="20%" class="my-2"></Skeleton>
        <Skeleton width="70%" height="2rem" class="my-2"></Skeleton>
      </div>
      <div class="col-12 my-3">
        <Skeleton width="10%" height="10rem"></Skeleton>
      </div>
    </div>

    <!-- form -->
    <form @submit.prevent="addOrUpdateService()" v-else>
      <div class="main_service">
        <h4 v-if="$route.params.id">{{ $t("Update Service") }}</h4>
        <h4 v-else>{{ $t("Add Service") }}</h4>
      </div>

      <div class="row">
        <!-- titles -->
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="Service_title_ar">
              {{ $t("Service_title_ar") }}
            </label>
            <input
              type="text"
              class="form-control"
              id="Service_title_ar"
              required
              v-model="Service_title_ar"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="Service_title_en">
              {{ $t("Service_title_en") }}
            </label>
            <input
              required
              type="text"
              class="form-control"
              id="Service_title_en"
              v-model="Service_title_en"
            />
          </div>
        </div>

        <!-- subtitles -->
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="Service_subtitle_ar">
              {{ $t("Service_subtitle_ar") }}
            </label>
            <input
              type="text"
              required
              class="form-control"
              id="Service_subtitle_ar"
              v-model="Service_subtitle_ar"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="Service_subtitle_en">
              {{ $t("Service_subtitle_en") }}
            </label>
            <input
              type="text"
              required
              class="form-control"
              id="Service_subtitle_en"
              v-model="Service_subtitle_en"
            />
          </div>
        </div>

        <!-- image upload -->
        <div class="col-12">
          <div class="form-group">
            <label class="form-label" for="Service_image">
              {{ $t("Service_image") }}
            </label>
            <input
              type="file"
              class="form-control"
              id="Service_image"
              accept="image/png, image/gif, image/jpeg, image/jpg"
              @change="onFileChange"
            />
          </div>

          <!-- preview -->
          <div class="main-image-container" v-if="singleImage">
            <div class="image-conteiner">
              <img :src="singleImage.preview" class="entry_image" />
              <div class="form-group mx-2">
                <label class="form-label" for="alt">alt</label>
                <input
                  class="form-control"
                  id="alt"
                  type="text"
                  v-model="singleImage.alt"
                />
              </div>
              <button
                type="button"
                class="btn btn-danger btn-sm ms-2"
                @click="removeImage"
              >
                X
              </button>
            </div>
          </div>
        </div>

        <!-- submit -->
        <div class="col-12">
          <button type="submit" class="btn PrimaryButton">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Skeleton from "primevue/skeleton";

export default {
  name: "addService",
  data() {
    return {
      v$: useVuelidate(),
      loading: true,
      Service_title_ar: "",
      Service_title_en: "",
      Service_subtitle_ar: "",
      Service_subtitle_en: "",
      singleImage: null, // {file, preview, alt}
      banner_id: this.$route.params.id,
    };
  },

  validations() {
    return {
      Service_title_ar: { required },
      Service_title_en: { required },
      Service_subtitle_ar: { required },
      Service_subtitle_en: { required },
      singleImage: { required },
    };
  },

  methods: {
    onFileChange(event) {
      const file = event.target.files[0];
      if (!file || !file.type.match("image.*")) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.singleImage = {
          file,
          preview: e.target.result,
          alt: "",
        };
      };
      reader.readAsDataURL(file);
    },

    removeImage() {
      this.singleImage = null;
    },

    async addOrUpdateService() {
      const formData = new FormData();
      formData.append("title_ar", this.Service_title_ar);
      formData.append("title_en", this.Service_title_en);
      formData.append("subtitle_ar", this.Service_subtitle_ar);
      formData.append("subtitle_en", this.Service_subtitle_en);

      if (this.singleImage?.file) {
        formData.append("image", this.singleImage.file);
      }
      formData.append("alt", this.singleImage?.alt || "");

      const url = this.banner_id ? "/update_service" : "/store_service";

      try {
        const { data } = await axios.post(url, formData);
        Swal.fire({
          text: data.message,
          icon: "success",
        });
        this.$router.push("/showservice");
      } catch (error) {
        Swal.fire({
          text: error.response?.data?.message || "Error",
          icon: "error",
        });
      }
    },

    async showService() {
      if (!this.banner_id) {
        this.loading = false;
        return;
      }

      try {
        const { data } = await axios.post("/show_service", {
          id: this.banner_id,
        });

        const service = data.data;
        this.Service_title_ar = service.title_ar;
        this.Service_title_en = service.title_en;
        this.Service_subtitle_ar = service.subtitle_ar;
        this.Service_subtitle_en = service.subtitle_en;

        if (service.image) {
          this.singleImage = {
            file: null,
            preview: service.image, // جاي من الـ API
            alt: service.alt || "",
          };
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
        Swal.fire({
          text: "فشل تحميل البيانات",
          icon: "error",
        });
      }
    },
  },

  mounted() {
    this.showService();
  },

  components: {
    Skeleton,
  },
};
</script>

<style scoped>
.image-conteiner {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.entry_image {
  width: 120px;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 10px;
}
</style>
